import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import OnboardingFlow from '../components/onboarding/OnboardingFlow';

export default function Onboarding() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  // Redirect to dashboard if onboarding is already completed
  useEffect(() => {
    if (currentUser?.onboardingCompleted) {
      navigate('/');
    }
  }, [currentUser, navigate]);

  return <OnboardingFlow />;
}
